import React from "react";

// eslint-disable-next-line no-restricted-imports
import { Breadcrumb as DSBreadcrumb, BreadcrumbProps } from "@packages/ds";

import { BreadcrumbLink } from "./Breadcrumb.styles";

export const Breadcrumb: React.FC<BreadcrumbProps> = props => (
  <DSBreadcrumb {...props} LinkComponent={BreadcrumbLink} />
);
